import React, { useState } from 'react'
 
 
 
import AccountSubroupList from './AccountSubroupList';
import AccountSubroupForm from './AccountSubroupForm';

const AccountSubgroup= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AccountSubroupForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AccountSubroupList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default AccountSubgroup